import styled from "@emotion/styled";

import { theme } from "shared/lib/styles";

import { ResponsiveContainer } from "scmp-app/components/header/features/styles";

export const AvatarContainer = styled(ResponsiveContainer)`
  inline-size: 32px;
  block-size: 32px;

  ${theme.breakpoints.up("tablet")} {
    inline-size: 42px;
    block-size: 42px;
  }
`;
